<template>
    <div class="trdemark-infozl">
        <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" style="
    margin-top:13px;margin-left:14px;">
      <el-breadcrumb-item>专利管理</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/PatentsSearch' }" >专利查询</el-breadcrumb-item>
       <el-breadcrumb-item class="breadSelected">专利信息详情页</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 内容区域 -->
    <div class="trdemark-mainzl">
        <div class="trdemark-titlezl">
            {{zlbasicDataDetails.sProposer1st}}
        </div>
        <!-- 基本信息 -->
        <div class="basic-infozl">
            <div class="trdemark-line">
                <div class="basic-header">
                    <div></div>
               基本信息
            </div>
            </div>
            <div class="basic-listzl">
                <!-- <div class="mark-img">
                    <img src="../assets/imgs/indexlogo.jpg" alt="">
                </div> -->
                <ul class="basic-namezl">
                    <li>专利名称：<span>{{zlbasicDataDetails.sTitle}}</span></li>
                    <li>申请号：<span>{{zlbasicDataDetails.sPatentnumber}}</span></li>
                    <li>申请日：<span>{{zlbasicDataDetails.dtApplydate}}</span></li>
                    <li>分类号：<span>{{zlbasicDataDetails.sMainipc}}</span></li>
                </ul>
                <ul class="basic-namezl">
                <li>专利类型：<span>{{zlbasicDataDetails.sPatenttype}}</span></li>
                <li>发明人 ：<span>{{zlbasicDataDetails.sInventor}}</span></li>
                 <li>公开号：<span>{{zlbasicDataDetails.sPubnumber}}</span></li>
                 <li>公开日：<span>{{zlbasicDataDetails.dtPubdate}}</span></li>
                 </ul>
                <ul class="basic-namezl">
                    <li>授权日：<span>{{zlbasicDataDetails.dtAuthdate}}</span></li>
                    <li>优先权：<span>{{zlbasicDataDetails.sPriority}}</span></li>
                    <li>终止日：<span>{{zlbasicDataDetails.dtEnddate}}</span></li>
                    <li>申请人类型：<span>{{zlbasicDataDetails.apty | applyerType}}</span></li>
                </ul>
            </div>
        </div>
        <!-- 申请人信息 -->
        <div class="basic-infozl">
             <div class="trdemark-line">
                <div class="basic-header">
                    <div></div>
               申请人信息
            </div>
            </div>
            <ul class="basic-namezl applicant">
                <li class="aoolicant-name">第一申请人：<span>{{zlbasicDataDetails.sProposer1st}}</span></li>
                <li>申请人地址：<span>{{zlbasicDataDetails.sAddress}}</span></li>
            </ul>
        </div>
        <!-- 代理机构信息 -->
        <div class="basic-infozl">
            <div class="trdemark-line">
                <div class="basic-header">
                <div></div>
               代理机构信息
            </div>
            </div>
        <ul class="basic-namezl agent">
            <li class="ag-name">代理人：<span>{{zlbasicDataDetails.sAgencyname}}</span></li>
             <li>代理机构：<span>{{zlbasicDataDetails.sAgency}}</span></li>
        </ul>
    </div>
    <!-- 流程信息-最后流程信息 -->
    <div class="basic-infozl no-border">
        <div class="trdemark-line">
                <div class="basic-header">
                <div></div>
               专利摘要
            </div>
            </div>
             <ul class="basic-namezl agent">
                 <div v-html="zlbasicDataDetails.sAbstract" class="agentzl"></div>
                 <!-- <span>{{ zlbasicDataDetails.sAbstract }}</span> -->
            </ul>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
    data() {
        return {
            // zlbasicDataDetails:'',
        }
    },
    computed: {
        ...mapState(['zlbasicDataDetails'])
    },
    created(){
        // console.log('zlbasicDataDetails',this.zlbasicDataDetails)
    }


    
}
</script>
<style lang="less" >
.trdemark-infozl {
  
    width: 98%;
    height: 98%;
    position: absolute;
    bottom: 0;
    background: #fff;
    left: 20px;
    overflow-y: auto;

}
        .basic-namezl {
           list-style: none;
           overflow: auto;
           display: flex;
    justify-content: space-between;
    margin: 0px 0px 12px 30px;
    
        }
        .basic-namezl > li {
            margin-bottom: 12px;
            font-size: 14px;
            color: #6b6b6b;
            line-height: 22px;
        }
        .basic-namezl >li span {
            color: #000;
            font-size: 14px;
            line-height: 22px;
        }
.applicant{
    display: flex;
    justify-content: flex-start;
    margin: 0px 0 30px 30px;
  
    .aoolicant-name {
        margin-right: 50px;
    }
}
.ag-name{
    margin-right: 50px;
}
.agent {
    display: flex;
    justify-content: flex-start;
    margin: 0px 0 30px 30px;
  
   
}
.agent div {
    text-indent: 2em;
    margin-bottom: 14px;
}
.trdemark-line {
    width: 80%;
}
.basic-header {
        display: flex;
        height: 30px;
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 700;
        color: #1773d5;
        line-height: 22px;
        letter-spacing: 0.5px;
    }
.basic-header > div {
    width: 4px;
    height: 16px;
    background: #1b75d5;
    border-radius: 2px;
    margin: 4px 27px 0px 0px;
        }
.trdemark-mainzl {
    overflow: hidden;
    min-height: 500px;
    margin-top: 7px;
    margin-left: 14px;
    min-height: 600px;
    background: #fff;
    .trdemark-titlezl {
    width: 95%;
    
    line-height: 40px;
    background: #e7f3ff;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #1773d5;
    letter-spacing: 0.5px;
    }
       .no-border {
    border: none !important;
}
    .basic-infozl {
        width: 90%;
        margin: 14px;
        border-bottom: 1px solid #dddddd;
    
    
        .basic-listzl {
            // margin-left: 14px;
            // display: flex;
            // justify-content: space-around;
            // padding: 15px 20px;
        .mark-img {
            width: 138px;
            height: 130px;
            background-color: pink;
            img {
                width: 24px;
                height: 24px;
            }
        }

        }
    }
}
.agentzl {
    font-size: 14px;
}
.agentzl >img {
    width: 40px;
    height: 40px;
}

</style>